<template>
    <v-dialog v-model="value" persistent max-width="500px">
        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title>{{ form.name ? 'Modifica Costo Aggiuntivo' : 'Aggiungi Costo Aggiuntivo'
                    }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="error" v-if="form.id" rounded small @click="$emit('delete', form.id)">
                    <v-icon left>delete</v-icon>Elimina
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form ref="formRef">
                    <v-text-field v-model="form.name" label="Nome" :rules="nameRules" required></v-text-field>

                    <v-text-field v-model="form.description" label="Descrizione"></v-text-field>
                    <float-input prepend-icon="euro" v-model="form.cost" label="Costo" :decimals="2" :rules="costRules"
                        required></float-input>
                    <v-text-field v-model="form.date" label="Data" type="date" :rules="dateRules" required></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn @click="$emit('input', false)">
                    <v-icon left>close</v-icon>Chiudi
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="handleSave" color="primary">
                    <v-icon left>save</v-icon>Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        form: Object,
    },
    data() {
        return {
            nameRules: [
                v => !!v || 'Il nome è richiesto',
                v => v.length >= 3 || 'Il nome deve contenere almeno 3 caratteri',
                v => v.length <= 128 || 'Il nome è troppo lungo',
            ],
            costRules: [
                v => !!v || 'Il costo è richiesto',
                v => !isNaN(v) && v > 0 || 'Il costo deve essere un numero maggiore di zero',
            ],
            dateRules: [
                v => !!v || 'La data è richiesta',
                v => new Date(v) instanceof Date && !isNaN(new Date(v)) || 'La data non è valida',
            ],
        };
    },
    methods: {
        handleSave() {
            if (this.$refs.formRef.validate()) {
                this.$emit('save');
            }
        },
    }
};
</script>
